import type { FC } from "react";
import { Card, Flex, IconButton, Spacing, Text } from "@huub-web/ui";
import { useTranslation } from "react-i18next";

export type AllAnalysisObservationsProps = {
  disabled?: boolean;
  length?: number;
  loading?: boolean;
  onClick?: () => void;
};

export const AllAnalysisObservations: FC<AllAnalysisObservationsProps> = ({
  disabled = false,
  length,
  loading = false,
  onClick,
}) => {
  const { t } = useTranslation();

  return (
    <Card
      variant={loading ? "tertiary" : "accent"}
      onClick={onClick}
      disabled={disabled}
    >
      <Flex gap="xs" direction="column" grow>
        <Text
          bold
          variant={loading ? "displayS" : "displayL"}
          color={loading ? "currentColor75" : undefined}
        >
          {loading ? <>&mdash;</> : length}
        </Text>
        <Text color={loading ? "currentColor50" : undefined} italic={loading}>
          {t(
            loading
              ? "analysis.observations.processing"
              : "analysis.observations.viewAll",
          )}
        </Text>
        {loading && <Spacing height="xxl" />}
      </Flex>
      {!loading && (
        <IconButton
          icon="chevronRight"
          as="div"
          variant="backgroundSecondary"
          rounded
        />
      )}
    </Card>
  );
};
